import * as React from 'react';
import Heading from 'components/text/Heading';
import { Legal } from 'model/contentful/legal';
import Paragraph from 'components/text/Paragraph';
import { renderRichText } from 'utils/contentful';
import View from 'components/View';

interface Props {
  legalData: Legal;
}

const Legal: React.FC<Props> = ({ legalData }) => {
  return (
    <View className="LegalContainer">
      <Heading className="mt-12 md:mt-24 mb-10" variant="h1">
        {legalData.title}
      </Heading>
      <Paragraph color="subtle" className="prose prose-md prose-neutral mt-2" element="div">
        {renderRichText(legalData.content?.json)}
      </Paragraph>
    </View>
  );
};

export default Legal;
